import { Route, Switch } from 'react-router-dom'
import './Global.css'
import AppProvider from './hooks'
import { ThemeProvider } from 'styled-components'
import { theme } from './styles/theme'
import Home from './pages/Home'
import End from './pages/End'
import Auth from './pages/Auth'
import GlobalStyles from './styles/global'
import TagManager from 'react-gtm-module'
import { useEffect } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// import HomeNew from './pages/HomeNew'

function App() {
  useEffect(() => {
    TagManager.initialize({
      gtmId: 'GTM-5QKH8R'
    })
  }, [])
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITEKEY}
    >
      <AppProvider>
        <ThemeProvider theme={theme}>
          <Switch>
            <Route exact path="/" component={Auth} />
            <Route exact path="/cadastro" component={Home} />
            {/* <Route exact path="/cadastroNovo" component={HomeNew} /> */}
            <Route exact path="/cadastro-sucesso" component={End} />
          </Switch>
          <GlobalStyles></GlobalStyles>
        </ThemeProvider>
      </AppProvider>
    </GoogleReCaptchaProvider>
  )
}

export default App
